import moment from 'moment';
import { CustomPopover } from '../../../components/custom-popover';
import { CommonTag, TagType } from '../../../components/tag';
import getFormatMessage from '../../../locales/get-format-message';
import { GameEnvType } from '../../../model/api-modules/env';
import timeIcon from '../../../assets/svg/time-icon.svg';

export interface IEnvTask {
  env_id: string;
  open_status: number;
  task: Record<string, any>;
}

export const renderEnvTypeTag = (type: GameEnvType) => {
  const tagMap: Record<GameEnvType, { color: TagType; text: string }> = {
    [GameEnvType.Dev]: {
      color: 'yellow',
      text: type,
    },

    [GameEnvType.Live]: {
      color: 'green',
      text: type,
    },
  };
  const tagConfig = tagMap[type];
  if (tagConfig) {
    return <CommonTag type={tagConfig.color} text={tagConfig.text} />;
  }

  return null;
};

export const getEnvTypeOptions = () => {
  return Object.values(GameEnvType).map((key) => {
    return { label: renderEnvTypeTag(key), value: key };
  });
};

export const renderEnvTaskStatus = (taskInfo?: IEnvTask) => {
  // open_status: -1 停服中
  // 0 默认值，开服；
  // 1 隐私白名单开服
  // 2 ip白名单开服
  //  status：
  // (0, '未执行'),
  // (1, '执行中'),
  // (2, '执行成功'),
  // (3, '执行失败'),
  // (4, '执行超时'),
  // (5, '手动终止'),
  // (6, '跳过执行'),
  // (7, '流水线执行成功')
  // k8s_app_task_type：
  // 526: '开启服务',
  // 527: '停止服务',

  if (taskInfo) {
    const task = taskInfo?.task;
    const reqDetail: any = task?.req_detail ? safeParse(task.req_detail) : {};
    const expectedExecutionTime = reqDetail?.expected_execution_time
      ? moment
          .unix(reqDetail?.expected_execution_time)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
      : '';
    let title = '';
    let color = '';
    let content = '';
    if (taskInfo.open_status === -1) {
      title = getFormatMessage('services_status_closed');
      color = '#F54E4E';
    } else if (taskInfo.open_status === 0) {
      title = getFormatMessage('services_status_opened');
      color = '#3EC688';
    } else if (taskInfo.open_status === 1) {
      title = getFormatMessage('services_status_white');
      color = '#3EC688';
    } else if (taskInfo.open_status === 2) {
      title = getFormatMessage('services_status_geo');
      color = '#3EC688';
    }
    if (task?.k8s_app_task_type === 526) {
      content = getFormatMessage('services_status_tips_opened', {
        params: { time: expectedExecutionTime },
      });
    } else if (task?.k8s_app_task_type === 529) {
      content = getFormatMessage('services_status_tips_switch', {
        params: { time: expectedExecutionTime },
      });
    } else {
      content = getFormatMessage('services_status_tips_closed', {
        params: { time: expectedExecutionTime },
      });
    }
    return (
      <div style={{ display: 'flex' }}>
        <span
          style={{
            display: 'block',
            width: 8,
            height: 8,
            background: color,
            borderRadius: '50%',
            marginTop: 6,
            marginRight: 8,
          }}
        ></span>
        <span>{title}</span>
        {expectedExecutionTime && task?.k8s_app_task_type && (
          <CustomPopover content={content}>
            <img
              src={timeIcon}
              style={{
                display: 'block',
                width: 16,
                height: 16,
                marginLeft: 8,
                marginTop: 2,
              }}
            />
          </CustomPopover>
        )}
      </div>
    );
  }
  return <div>--</div>;
};

const safeParse = (data: unknown) => {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (e) {
      console.warn('JSON 解析失败', e);
      return {};
    }
  }
  return data;
};
